import { Segmented } from 'antd';
import { SegmentedLabeledOption } from 'antd/es/segmented';
import styled from 'styled-components';
import { themeConfig, useThemeContext } from '@/shared/theme';
import { ChatMode } from '@/shared/types';
import { ConversationMode } from '../model/types';

type ChatConversationSwitchProps = {
  chatMode?: ChatMode;
  conversationOptions: Array<SegmentedLabeledOption>;
  conversationMode: ConversationMode;
  onChatConversationChange: (value: ConversationMode) => void;
};

const ChatConversationSwitch = ({
  chatMode,
  conversationOptions,
  conversationMode,
  onChatConversationChange,
}: ChatConversationSwitchProps) => {
  const { theme } = useThemeContext();

  return (
    <>
      {chatMode === ChatMode.Author ? '' : 'Chat with'}
      <SegmentedWrapper
        data-testid="chat-segmented"
        options={conversationOptions}
        value={conversationMode}
        onChange={(value) => {
          onChatConversationChange(value as ConversationMode);
        }}
        $primary={themeConfig[theme].colors.primary}
      />
    </>
  );
};

export default ChatConversationSwitch;

const SegmentedWrapper = styled(Segmented)<{ $primary: string }>`
  .ant-segmented-item-selected,
  .ant-segmented-thumb {
    background: ${(props) => props.$primary};
    color: #fff;
    transition: all 0.000001s;
  }
  .ant-badge {
    color: inherit;
  }
`;
